"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { useAuth } from "@/contexts/auth-context";
import { usePluginStore } from "@/stores/usePluginStore";

/**
 * Binds the plugin store to the authenticated user id.
 * Auth-generation advances stay in ConnectorOAuthCoordinatorProvider only.
 */
export function PluginAuthScopeSync() {
  const $ = _c(8);
  const {
    user
  } = useAuth();
  const setAuthScopeKey = usePluginStore(_temp);
  const reset = usePluginStore(_temp2);
  const previousScopeKey = useRef(null);
  let t0;
  if ($[0] !== reset || $[1] !== setAuthScopeKey || $[2] !== user?.id) {
    t0 = () => {
      const nextScopeKey = user?.id ?? null;
      if (previousScopeKey.current !== nextScopeKey) {
        if (previousScopeKey.current) {
          reset();
        }
        previousScopeKey.current = nextScopeKey;
        setAuthScopeKey(nextScopeKey);
      }
    };
    $[0] = reset;
    $[1] = setAuthScopeKey;
    $[2] = user?.id;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const t1 = user?.id;
  let t2;
  if ($[4] !== reset || $[5] !== setAuthScopeKey || $[6] !== t1) {
    t2 = [reset, setAuthScopeKey, t1];
    $[4] = reset;
    $[5] = setAuthScopeKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t0, t2);
  return null;
}
function _temp2(state_0) {
  return state_0.reset;
}
function _temp(state) {
  return state.setAuthScopeKey;
}